import { isArray } from 'lodash';
import { getColors } from '../common/callAPIs';
import { useEffect, useState } from 'react';

export function useLoadColors(queryInfo) {
  const [colorList, setColorList] = useState([]);

  useEffect(() => {
    loadColors();
  }, []);

  const loadColors = async () => {
    getColors(queryInfo)
      .then((res) => res.json())
      .then((data) => {
        if (!isArray(data)) throw new Error('Retrieved colors is not an array');
        setColorList(data);
      })
      .catch((error) => {
        console.log('ERROR WHEN LOADING COLORS', error);
      });
  };

  return { colorList };
}
